<template>
  <div>
    <v-app>
    <my-asidebar v-bind:active-tab="'accesslogs'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Endpoint Stats </h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/endpointStats'" class="text-white">Endpoint Stats</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-main-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <form id="portForm">
                  <div class="form-box">
                    <endpoint-stats-list/>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </v-app>
  </div>
</template>

<script>
import PortDetail from "../component/port/PortDetail";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
import messagePopupManager from "../util/messagePopupManager";
import EndpointStatsList from "../component/auth/EndpointStatsList";

export default {
  name: "EndpointStatsPage",
  components: {EndpointStatsList, TopBar, MyAsidebar,  PortDetail},
  data () {
    return {
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_ENDPOINT_STATS"]) this.$router.push("/");
    this.loadAccessLogs();
  },
  methods: {
    loadAccessLogs(){
      this.$store.dispatch("loadEndpointStats");
    }
  }
}
</script>

<style scoped>

</style>